import * as React from 'react';
import { CSSProperties, useContext, useMemo } from 'react';
import { useTheme } from '../../../theme';
import cn from 'classnames';
import { getReadablePeriod } from '../../hooks';
import OrderCities from './OrderCities/OrderCities';
import { OrderCardContext } from '../OrderCard';

interface Props {
	className?: string;
	onClick?: () => void;
}

const OrderPreview: React.FC<Props> = ({ className, onClick }) => {
	const { OrderPreview: css } = useTheme('OrderCard');
	const { order } = useContext(OrderCardContext);

	const period = getReadablePeriod(order);
	const styles = useMemo<CSSProperties>(() => {
		const segments = order.flight.segmentGroups[0].segments;
		const overlay = segments[segments.length - 1].arrival.airport?.city?.images?.panorama?.url;
		if (overlay) {
			return {
				backgroundImage: `url('${overlay}')`
			};
		} else {
			return {};
		}
	}, [order.flight.segmentGroups]);

	return (
		<div className={cn(css.root, className, { [css.clickable]: onClick })} onClick={onClick} style={styles}>
			<div className={css.overlay} />
			<div className={css.inner}>
				<OrderCities flight={order.flight} />
				<div className={css.period}>{period}</div>
			</div>
		</div>
	);
};

export default OrderPreview;
